import { rawToValidReportType } from '@/utils/index';
import { Notification, NormalizedNotification } from './types';

type NotificationOrigin = 'sriracha';

function generateNotification(
  notification: Notification,
  notificationOrigin: NotificationOrigin
): Partial<NormalizedNotification> {
  const { title, body, data, link } = notification;

  const notificationTypes = {
    sriracha: {
      suggested_report: {
        title,
        body,
        data: { ...data, ...data.query_params },
        parentSource: data.parent_source,
        reportType: rawToValidReportType(data.report_type),
        suggestedReportSource: data.suggested_report_source,
      },
      report_update: {
        title,
        body,
        section: data.report_section,
        permalink: data.permalink,
        reportType: rawToValidReportType(data.report_type),
      },
      lizano_bulk_search: {
        title: 'Your list report is ready',
        route: '/dashboard/lists',
        listCode: data.list_code,
      },
      welcome: {
        title,
        body,
      },
      new_feature: {
        title,
        body,
        data,
      },
    },
    default: {
      title,
      body,
      permalink: link !== null ? link : data.permalink,
    },
  };

  const notificationType = notificationTypes[notificationOrigin];
  const notificationData =
    notificationType[notification.notification_type] ||
    notificationTypes.default;

  return notificationData;
}

export function normalizeNotificationObject(
  notification: Notification,
  notificationOrigin: NotificationOrigin
): NormalizedNotification {
  const { id, read_at, notification_type, created_at } = notification;
  const details = generateNotification(notification, notificationOrigin);

  return {
    id,
    read: !!read_at,
    created_at,
    type: notification_type,
    title: details.title || '',
    body: details.body || '',
    permalink: details.permalink || '',
    ...details,
  };
}
